import cn from 'classnames';
import React, { ReactNode } from 'react';

import s from './Label.module.scss';

interface LabelProps {
  children: ReactNode;
  customStyle?: string;
  type?: string;
  color?: string;
  background?: string;
}

const setStyle = (styleType?: string) => {
  switch (styleType?.toLowerCase()) {
    case 'warning':
      return 'isWarning';
    case 'error':
      return 'isError';
    case 'new':
      return 'isNew';
    case 'recommended':
      return 'isRecommended';
    default:
      return styleType;
  }
};

const Label = ({ children, customStyle, type, color, background }: LabelProps) => {
  const styleType = setStyle(type);

  if (!children) {
    return null;
  }

  return (
    <div
      className={cn(s.Label, customStyle, styleType)}
      style={{ color, backgroundColor: background }}
    >
      {children}
    </div>
  );
};

export default Label;
